import { yupResolver } from '@hookform/resolvers/yup';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, Button, IconButton, InputAdornment } from '@mui/material';
import { FormInput } from 'components/input/hook-form';
import ButtonLoader from 'components/loader/ButtonLoader';
import { IForgotPasswordBody } from 'interfaces/forgot-password';
import { useForgotPasswordMutation } from 'lib/api/authApi';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import * as yup from 'yup';

const EmployeeForgotPasswordForm = () => {
    const { sessionId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [forgotPassword] = useForgotPasswordMutation();

    const { handleSubmit, control } = useForm<IForgotPasswordBody>({
        mode: 'onSubmit',
        defaultValues: {
            sessionId: sessionId || ''
        },
        resolver: yupResolver(
            yup
                .object({
                    sessionId: yup.string().required('*Session ID is required'),
                    otp: yup.number().min(6).required('*OTP is required'),
                    newPassword: yup.string().min(6, '*Password must be at least 6 characters')
                })
                .required()
        )
    });

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const onSubmit = (data: IForgotPasswordBody) => {
        setLoading(true);
        forgotPassword(data)
            .unwrap()
            .then(() => {
                withReactContent(Swal).fire('Sukses', 'Password changed successful!', 'success');
                navigate(`/login/`);
            })
            .catch((error) => {
                withReactContent(Swal).fire('Error', error.data?.message || 'An error occurred while processing your request.', 'error');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ mb: 20 }}>
                <FormInput control={control} label="OTP" name="otp" type="number" />
            </Box>
            <Box sx={{ mb: 20 }}>
                <FormInput
                    control={control}
                    label="New Password"
                    name="newPassword"
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end" size="large">
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </Box>
            <Box sx={{ mt: 2 }}>
                {loading ? (
                    <ButtonLoader />
                ) : (
                    <Button disableElevation fullWidth size="large" type="submit" variant="contained" color="secondary">
                        Change Password
                    </Button>
                )}
            </Box>
        </form>
    );
};

export default EmployeeForgotPasswordForm;
